import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Sidebar from '../components/Sidebar';
import TopNav from '../components/TopNav';
import ShareQrCard from '../components/ShareQrCard';
import useAuthStore from '../store/authStore';
import { academicService, blogService } from '../services/api';
import { Card, Select, Spinner } from '../components/ui';

export default function TeacherShare() {
  const { t } = useTranslation();
  const user = useAuthStore((state) => state.user);
  const [modules, setModules] = useState([]);
  const [blog, setBlog] = useState(null);
  const [courseId, setCourseId] = useState('');
  const [loading, setLoading] = useState(true);
  const origin = window.location.origin;

  useEffect(() => {
    Promise.allSettled([academicService.getMyModules(), blogService.getMyBlog()]).then(([moduleResult, blogResult]) => {
      if (moduleResult.status === 'fulfilled') {
        const data = moduleResult.value.data;
        const items = Array.isArray(data) ? data : data.results || [];
        setModules(items); if (items[0]) setCourseId(String(items[0].id));
      }
      if (blogResult.status === 'fulfilled') {
        const data = blogResult.value.data;
        setBlog(Array.isArray(data) ? data[0] : data.results?.[0] || data);
      }
      setLoading(false);
    });
  }, []);

  const selected = modules.find((item) => String(item.id) === courseId);
  const blogUrl = useMemo(() => {
    if (!blog?.subdomain) return '';
    if (window.location.hostname === 'lmcid.com' || window.location.hostname === 'www.lmcid.com') return `https://${blog.subdomain}.lmcid.com`;
    return `${origin}/blog/${blog.subdomain}`;
  }, [blog, origin]);

  return <div className="flex h-screen bg-surface-50"><Sidebar /><div className="flex min-w-0 flex-1 flex-col overflow-hidden"><TopNav title={t('QR sharing studio')} subtitle={t('Turn your teaching presence into a scannable experience')} /><main className="flex-1 overflow-y-auto p-4 pb-24 sm:p-6"><div className="mx-auto max-w-6xl">
    <Card className="mb-6 overflow-hidden bg-gradient-to-r from-slate-950 to-primary-800 p-7 text-white"><p className="text-xs font-bold uppercase tracking-[.2em] text-primary-200">L’mcid Share</p><h1 className="mt-2 text-3xl font-bold">{t('One scan. Straight to your content.')}</h1><p className="mt-2 max-w-2xl text-sm text-primary-100">{t('Share these QR codes in classrooms, social posts or printed materials.')}</p></Card>
    {loading ? <div className="grid min-h-56 place-items-center"><Spinner /></div> : <div className="grid gap-5 lg:grid-cols-3">
      <ShareQrCard value={`${origin}/teachers/${user.id}`} title={t('Teacher profile')} description={t('Introduce your experience and published courses.')} />
      {blogUrl ? <ShareQrCard value={blogUrl} title={t('Teacher blog')} description={t('Send readers directly to your latest articles.')} /> : <Card className="grid place-items-center p-7 text-center text-gray-500">{t('Create and publish your blog to generate its QR code.')}</Card>}
      <div><div className="mb-3"><Select value={courseId} onChange={(event) => setCourseId(event.target.value)}>{modules.map((module) => <option key={module.id} value={module.id}>{module.name || module.title}</option>)}</Select></div>{selected ? <ShareQrCard value={`${origin}/modules/${selected.id}`} title={selected.name || selected.title} description={t('Open this course directly after scanning.')} /> : <Card className="p-7 text-center text-gray-500">{t('Publish a course to generate its QR code.')}</Card>}</div>
    </div>}
  </div></main></div></div>;
}
